import { publicEnvConfigSchema } from '../public-env-config.ts';

export const PUBLIC_PATHS = ['/sign-in(.*)', '/sign-up(.*)'];

// Runtime config served by the backend at /config.js (see server/server.ts)
const config = publicEnvConfigSchema.parse(window.__APP_CONFIG__);

export const {
    APP_ENV,
    CLERK_PUBLISHABLE_KEY,
    INTERCOM_APP_ID,
    POSTHOG_HOST,
    POSTHOG_KEY,
    UPLOADCARE_CDN_NAME,
    UPLOADCARE_PUBLIC_KEY,
} = config;

// this is baked into the bundle at build time
const release: unknown = import.meta.env.VITE_APP_RELEASE;
export const VITE_APP_RELEASE = typeof release === 'string' ? release : undefined;
